import React, { useEffect, useRef, useState } from 'react'
import classes from "./style.module.scss";
import CloseIcon from '@mui/icons-material/Close';
import ModalDropdown from '../../../../component/ModalDropdown';
import Button from '../../../../component/Button';
import { useNavigate } from 'react-router-dom';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { Toast } from '../../../../service/toast';
import moment from 'moment';
import { displayFileType } from '../../../../helpers';

const ViewRewards = (props) => {
    const { isOpen = false, closePopUp, rewardId, handleSuccessModal } = props

    const navigate = useNavigate();
    const [detailInfo, setDetailInfo] = useState({})

    useEffect(() => {
        if (rewardId) {
            getDetails(rewardId)
        }
    }, rewardId)

    const onEdit = () => {
        handleSuccessModal();
        navigate(`?type=edit?id=${rewardId}`)
    };

    const getDetails = async (id) => {
        let url = `${Exported.Endpoints.getRewardByID}/${id}`
        let paramsObj = {
            id: id,
        }
        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                setDetailInfo(res?.data?.data)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    return (
        <>
            <ModalDropdown isOpen={isOpen} closePopUp={closePopUp}>
                <div className={`${classes.viewRewardsWrapper}`}>
                    <div className={`${classes.modalHeader} flex items-center justify-between`}>
                        <div className={`${classes.modalTitle}`}>{detailInfo?.title}</div>
                        <div className={`${classes.modalCloser}`}>
                            <CloseIcon onClick={() => closePopUp()} />
                        </div>
                    </div>
                    <div className={`${classes.rewardsContainer}`}>
                        <div>
                            <div className={classes.informationHeader}>Expiry date</div>
                            <span className={classes.rewardsList}>{detailInfo?.expiry_date ? moment(detailInfo?.expiry_date)?.format('DD MMM YYYY') : ''}</span>
                            <div className={classes.informationHeader}>Details</div>
                            <ul>
                                <li className={classes.rewardsList}>{detailInfo?.reward_details}</li>
                                {/* <li className={classes.rewardsList}>Minimum Rs 500 spend</li>
                                <li className={classes.rewardsList}>Get Rs150 - Rs300 cashback when you transact with flipkart using Googlepay</li>
                                <li className={classes.rewardsList}>No code needed. Just tap”redeem now” & your voucher will be automatically applied when you pay.</li>
                                <li className={classes.rewardsList}>Only one redemption per user.</li> */}
                            </ul>
                            {detailInfo?.image ?
                                <>
                                    <div className={classes.informationHeader}>Images/Video</div>
                                    <div className={`${classes.displayProductWrapper}`}>
                                        <div className={classes.productLogoWrap}>
                                            {displayFileType(detailInfo?.image)}
                                        </div>
                                    </div>
                                </> : null}
                        </div>
                        <div className='flex justify-end'>
                            <Button text={"Edit"} className={`w-[150px] my-4`} style={{ width: "150px" }} smallBtn onClick={() => onEdit()} />
                        </div>
                    </div>
                </div>
            </ModalDropdown>
        </>
    );
}

export default ViewRewards;